import React from "react";
import { ChevronDown, Search } from "lucide-react";
import { Button, ButtonVariant, TextField } from "@merge-api/merge-javascript-shared";

/**
 * Static placeholder version of ScopesToolbar for the brief pre-category-resolve frame. Renders the
 * Sort / Filter / Search / Edit chrome in its normal (non-disabled) appearance so it looks identical
 * to the live toolbar; the loading signal lives in the skeleton table rows below. This matches the
 * convention (and MF style guide) of keeping toolbar chrome live and only skeletoning API-loaded rows.
 */
const ScopesToolbarSkeleton = () => (
  <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between lg:gap-x-5">
    <div className="flex flex-wrap items-center gap-4">
      <Button variant={ButtonVariant.TertiaryWhite} rightIcon={<ChevronDown size={16} />}>
        Sort by: Name (A-Z)
      </Button>
      <Button variant={ButtonVariant.TertiaryWhite}>Filter</Button>
      <TextField
        className="w-full lg:w-[400px] lg:flex-1"
        placeholder="Search Scopes and fields"
        prefix={
          <div className="pl-3">
            <Search size={16} className="text-gray-40" />
          </div>
        }
        inputClassName="pl-2"
      />
    </div>
    <Button variant={ButtonVariant.PrimaryGray}>Edit</Button>
  </div>
);

export default ScopesToolbarSkeleton;
